import { useEffect, useRef, useState } from 'react';

interface HeaderProps {
  onNavClick: (id: string) => void;
}

export default function Header({ onNavClick }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'comments', label: '漫友热评' },
    { id: 'ranking', label: '人气排行' },
    { id: 'media', label: '漫剪精选' },
    { id: 'cards', label: '编辑力荐' },
    { id: 'about', label: '关于尾巴' },
    { id: 'app', label: '客户端' },
  ];

  const handleClick = (id: string) => {
    setMobileOpen(false);
    onNavClick(id);
  };

  return (
    <header
      ref={headerRef}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleClick('hero');
            }}
            className="flex items-center gap-2 text-xl font-heading text-foreground-950 whitespace-nowrap cursor-pointer no-underline"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
              尾
            </span>
            尾巴漫画
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleClick('hero');
              }}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(item.id);
                }}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleClick('hero');
              }}
              className="ml-3 px-5 py-2 text-sm bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline font-medium"
            >
              开始阅读
            </a>
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer bg-transparent border-0"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleClick('hero');
              }}
              className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors cursor-pointer no-underline"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(item.id);
                }}
                className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors cursor-pointer no-underline"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleClick('hero');
              }}
              className="mt-2 px-5 py-3 text-sm text-center bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors cursor-pointer no-underline font-medium"
            >
              开始阅读
            </a>
          </div>
        </div>
      )}
    </header>
  );
}